// extracted by mini-css-extract-plugin
export default {"helperString":"form-block_helperString__YbDgk","placeHolderShimmer":"form-block_placeHolderShimmer__+8YE1"};